import routes from '@/Router/routes.constants'

import * as helpers from './helpers'

const useReturnPortals = ({ returnPortals, selectedReturnPortal, updateContext }) => {
  const onChangeReturnPortal = portalId => {
    const portal = returnPortals?.find(portal => portal.id === portalId)
    const store = portal?.store
    const { store: _, ...returnPortalForStorage } = portal || {}
    localStorage.selectedReturnPortal = JSON.stringify(returnPortalForStorage)
    localStorage.selectedStore = JSON.stringify(store)
    localStorage.forceChangeReturnPortal = true
    localStorage.forceChangeStore = true
    updateContext(info => ({ ...info, selectedReturnPortal: portal, selectedStore: store }))

    if (helpers.isConfigPage(window.location.pathname)) {
      helpers.reloadPage()
    } else {
      helpers.navigateTo(routes.dashboardPage)
    }
  }

  const getSelectedReturnPortal = () => {
    return selectedReturnPortal?.id ? selectedReturnPortal : returnPortals?.[0]
  }

  return { onChangeReturnPortal, getSelectedReturnPortal }
}

export default useReturnPortals
